const EmptyStateIcon = () => (
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="5" rx="2.5" fill="#C4C4C4" />
    <rect y="8" width="28" height="5" rx="2.5" fill="#C4C4C4" />
    <rect y="16" width="28" height="5" rx="2.5" fill="#C4C4C4" />
    <rect y="24" width="28" height="5" rx="2.5" fill="#C4C4C4" />
    <circle cx="2.5" cy="10.5" r="1.5" fill="white" />
    <circle cx="2.5" cy="2.5" r="1.5" fill="white" />
    <circle cx="2.5" cy="18.5" r="1.5" fill="white" />
    <circle cx="2.5" cy="26.5" r="1.5" fill="white" />
  </svg>
);

export default EmptyStateIcon;
